import React from "react";
import ConsultaCatalogos from "../../../components/ConsultaCatalogos/ConsultaCatalogos";

export default function ConsultarCatalogo(props) { 
    return (
        <div>
            <ConsultaCatalogos />
        </div>
    );
}